import React from 'react';
import PropTypes from 'prop-types';
import AppBar from './app-bar/index';
import {MuiThemeProvider, createMuiTheme, withStyles} from 'material-ui/styles';
import blue from '../../common/material-ui-colors/blue';
import amber from 'material-ui/colors/amber';

const theme = createMuiTheme({
	palette: {
		primary: blue,
		secondary: amber
	}
});

const styles = () => ({
	'@global html, body': {
		backgroundColor: '#EEE'
	}
});

const AdminLayout = ({children, handleGoBack, isHomepage}) => (
	<MuiThemeProvider theme={theme}>
		<AppBar handleGoBack={handleGoBack} isHomepage={isHomepage}/>
		{children}
	</MuiThemeProvider>
);

AdminLayout.propTypes = {
	children: PropTypes.node.isRequired,
	isHomepage: PropTypes.bool.isRequired,
	handleGoBack: PropTypes.func.isRequired
};

export default withStyles(styles)(AdminLayout);



// WEBPACK FOOTER //
// ./src/client/components/admin/layout/layout.jsx